import { ChangeDetectionStrategy, booleanAttribute, Component, computed, input, output } from "@angular/core";
import { RouterModule } from "@angular/router";
import { IButtonDirective, IIconComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-grid-layout",
  imports: [RouterModule, TranslocoDirective, IButtonDirective, IIconComponent],
  templateUrl: "./grid-layout.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridLayoutComponent {
  withExport = input(false, { transform: booleanAttribute });
  withImport = input(false, { transform: booleanAttribute });
  withRestoreColumns = input(false, { transform: booleanAttribute });

  withActionsHeader = computed(() => this.withExport() || this.withImport() || this.withRestoreColumns());

  export = output<void>();
  import = output<void>();
  columnRestore = output<void>();
}
